module.exports = [
  // {
  //   __typename: 'WpPage_Pagebuilder_Layouts_ImageText',
  //   kicker: 'LeadBoxer Platform',
  //   heading: 'Lead & Customer Data Platform',
  //   text: `
  //       <p class="text-xl leading-loose">By combining all your customer and lead activity in one interface, we generate valuable insights by creating rich profiles and analysing combined website and email behaviour.</p>
  //       <p class="leading-loose">Our modern web-app contains views on both individuals (leads) AND grouped by organization (accounts): making the app perfect for Account-Based Marketing or Sales</p>
  //     `,
  //   buttons: [
  //     {
  //       label: 'Request demo',
  //       type: 'primary',
  //       destination: {
  //         __typename: 'WpPage',
  //         uri: '/demo',
  //       },
  //     },
  //   ],
  //   image: {
  //     align: 'right',
  //     background: false,
  //     altText: '',
  //     title: 'LeadBoxer_App_and_LeadBoxer_App',
  //     description: '',
  //   },
  // },
  // {
  //   __typename: 'WpPage_Pagebuilder_Layouts_ImageText',
  //   kicker: 'What LeadBoxer does?',
  //   heading: 'Powerful Application',
  //   text: `
  //       <p>Even though the real value is inside the data, a good user interface is essential to find the needles in the (Big) Data haystack.</p>
  //       <p>Our modern web-app contains views on both individuals (leads) AND grouped by organization (accounts): making the app perfect for Account-Based Marketing or Sales</p>
  //     `,
  //   buttons: [
  //     {
  //       label: 'Request demo',
  //       type: 'primary',
  //       destination: {
  //         __typename: 'WpPage',
  //         uri: '/demo',
  //       },
  //     },
  //   ],
  //   image: {
  //     align: 'left',
  //     background: false,
  //     altText: '',
  //     title: 'LeadBoxer_App_and_LeadBoxer_App',
  //     description: '',
  //   },
  // },
]
